import React from 'react'
import style from "../../../../../style.module.css";
import Card from "../../../../../../core/Card";
import { useTranslation } from 'react-i18next';

const DeleteModal = ({ currentlyDeletingField, setCurrentlyDeletingField, handleDeleteField }) => {
    const { t, i18n } = useTranslation();

    return (
        <>
            <div className="customvar-modal modal custom-modal fade deleteModal" id="deleteLeadGenFieldModal" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer " + style.container}>
                                <div className={"formvawrapper delete-modal-wrap modal-sm " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p-0 " + style.card} >

                                        <div className="delete-body-wrap delete-language">
                                            <div className="heading">
                                                <h3>{t('survey.builder.delete')}</h3>
                                                <p>{t('survey.customFormula.del1')}, <strong>{currentlyDeletingField?.name ?? ''}</strong>? </p>
                                            </div>


                                            <div className="button-wrap d-flex justify-content-end">
                                                <button type="button" className="btn btn-bordered" data-bs-dismiss="modal" onClick={() => setCurrentlyDeletingField(null)}>{t('survey.customFormula.cancel')}</button>
                                                {window.modulePermissions.M12.del == 1 && (
                                                <button type="button" className="btn btn-delete ms-3" data-bs-dismiss="modal" onClick={() => handleDeleteField(currentlyDeletingField?.id)}>{t('survey.customVariable.confirm_delete')}</button>
                                                )}
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DeleteModal